var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.3325,89.9664L79.1447,70.7786c14.7465-19.367,11.0009-47.0214-8.3661-61.768 S23.7572-1.9902,9.0107,17.3767s-11.0009,47.0214,8.3661,61.768c15.7745,12.0111,37.6274,12.0111,53.4019,0l19.1878,19.1878 c2.3466,2.2738,6.0922,2.2148,8.3661-0.1318C100.5558,95.9062,100.5558,92.261,98.3325,89.9664z M21.461,66.9026 C8.9126,54.3526,8.9139,34.0064,21.4639,21.458s32.8962-12.547,45.4445,0.0029s12.5471,32.8962-0.0029,45.4445 c-6.0269,6.0261-14.2009,9.4112-22.7237,9.4104C35.6603,76.3112,27.4889,72.9257,21.461,66.9026z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.788f5c742029d38ec4ea4aba3807d97f.svg";
export { ForwardRef as ReactComponent };